/**
 * @file JobSearchEmptySlot.tsx
 *
 * @fileoverview Renders job detail instructions if none job is selected.
 */

import React from 'react';
import Image from '~/jobiqo/components/Image';
import styles from './jobSearchEmptyCustom.module.scss';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { FormattedMessage } from 'react-intl';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';

interface JobSearchEmptySlotProps {
  /**
   * The count of jobs.
   */
  totalCount?: Slottable<number>;
}

export const JobSearchEmptySlot = ({}: JobSearchEmptySlotProps) => {
  return (
    <div className={styles.emptySearchWrapper}>
      <Image
        alt={'Deine Ergebnisse'}
        src={'/static/images/job_search_empty.png'}
        width={768}
        height={600}
      />
      <Spacing />
      <FormattedMessage
        id="job_detail_panel_instructions"
        defaultMessage="To see all the details of a job posting please choose one from the list on the left."
      />
    </div>
  );
};
export default JobSearchEmptySlot;
